import { atom } from "jotai";

export type Framework = {
    id: string;
    name: string;
};

// Default frameworks - can be moved to a constants file if needed
export const DEFAULT_FRAMEWORKS: Framework[] = [
    { id: "ecovadis", name: "Ecovadis" },
];

// Guidance state management
export const selectedFrameworkAtom = atom<string>("");
export const isGuidanceActiveAtom = atom<boolean>(false);
